import { memo } from "react";
import Page from "components/page/Page";
import { Helmet } from "react-helmet";
import Card from "components/card/Card";
import { Link } from "react-router-dom";
import { PageCollapseWidth } from "../../constants";

const NotFoundPage = () => {
  return (
    <>
      <Helmet>
        <title>404 - Page Not Found | ToolWeaver</title>
        <meta
          name="description"
          content="The page you're looking for could not be found. Return to ToolWeaver's homepage to access our free online tools."
        />
      </Helmet>
      <Page>
        <Card collapseOnWidth={PageCollapseWidth} title="404 - Page Not Found">
          <span className="d-block mb-3">
            Sorry, the page you're looking for doesn't exist or has been moved.
          </span>
          <span className="d-block mb-3">Here are some helpful links:</span>
          <ul>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/base64encode">Base64 Encode</Link>
            </li>
            <li>
              <Link to="/base64decode">Base64 Decode</Link>
            </li>
            <li>
              <Link to="/guidgenerate">GUID Generate</Link>
            </li>
            <li>
              <Link to="/md5hash">MD5 Hash</Link>
            </li>
            <li>
              <Link to="/urlencode">URL Encode</Link>
            </li>
            <li>
              <Link to="/urldecode">URL Decode</Link>
            </li>
          </ul>
          <span className="d-block">
            If you believe this is an error, please{" "}
            <Link to="/contact">contact us</Link>.
          </span>
        </Card>
      </Page>
    </>
  );
};

export default memo(NotFoundPage);
